<template>
  <div class="unit-info-container">
    <!-- 左侧蓝色标记和标题 -->
    <div class="page-header">
      <div class="blue-bar"></div>
      <h2 class="page-title">单位信息管理</h2>
    </div>
    
    <!-- 搜索区域 -->
    <div class="search-area">
      <div class="search-inputs">
        <div class="search-item">
          <el-input
            v-model="searchForm.unitName"
            placeholder="单位名称"
            prefix-icon="el-icon-search"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-input
            v-model="searchForm.contactPerson"
            placeholder="联系人"
            clearable
          ></el-input>
        </div>
        <div class="search-item">
          <el-input
            v-model="searchForm.phone"
            placeholder="联系人电话"
            clearable
          ></el-input>
        </div>
        <div class="search-buttons">
          <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
          <el-button v-permission="'basic:units-list:create'" type="primary" @click="showAddDialog" icon="el-icon-plus">新增单位</el-button>
        </div>
      </div>
    </div>
    
    <!-- 表格区域 -->
    <div class="table-container">
             <el-table
         :data="tableData"
         border
         stripe
         style="width: 100%"
         v-loading="loading"
         :header-cell-style="{background:'#f5f7fa', color:'#606266'}"
       >
         <el-table-column prop="unitName" label="单位名称" width="250"></el-table-column>
         <el-table-column prop="contactPerson" label="联系人"></el-table-column>
         <el-table-column prop="phone" label="联系人电话"></el-table-column>
         <el-table-column prop="taxId" label="税号"></el-table-column>
         <el-table-column prop="address" label="单位地址" width="350"></el-table-column>
         
         <!-- 单位简称和简称首字母列 -->
         <el-table-column label="单位简称" prop="unitShortName" show-overflow-tooltip>
           <template slot-scope="scope">
             <span>{{ scope.row.unitShortName || '-' }}</span>
           </template>
         </el-table-column>
         
         <el-table-column label="简称首字母" prop="shortNameInitial" show-overflow-tooltip>
           <template slot-scope="scope">
             <span>{{ scope.row.shortNameInitial || '-' }}</span>
           </template>
         </el-table-column>
         
         <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button
              v-permission="'basic:units-list:edit'"
              size="mini"
              type="text"
              class="edit-btn"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <el-button
              v-permission="'basic:units-list:delete'"
              size="mini"
              type="text"
              class="delete-btn"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    
    <!-- 新增/编辑对话框 -->
    <el-dialog
      :title="dialogStatus === 'add' ? '新增单位' : '编辑单位'"
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :show-close="true"
      center
      class="unit-dialog"
      @closed="handleUnitDialogClosed"
    >
      <el-form :model="unitForm" :rules="rules" ref="unitForm" label-width="100px">
        <!-- 第一行：单位名称，税号 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位名称" prop="unitName">
              <el-input v-model="unitForm.unitName" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="税号" prop="taxId">
              <el-input v-model="unitForm.taxId" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 第二行：单位简称，简称首字母 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="单位简称" prop="unitShortName">
              <el-input 
                v-model="unitForm.unitShortName" 
                placeholder="请输入单位简称（6字符以内）"
                maxlength="6"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="简称首字母" prop="shortNameInitial">
              <el-input 
                v-model="unitForm.shortNameInitial" 
                placeholder="请输入简称首字母（6字符以内）"
                maxlength="6"
                show-word-limit
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 第三行：联系人，联系人电话 -->
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="联系人" prop="contactPerson">
              <el-input v-model="unitForm.contactPerson" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人电话" prop="phone">
              <el-input v-model="unitForm.phone" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <!-- 最后一行：单位地址 -->
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="单位地址" prop="address">
              <el-input v-model="unitForm.address" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <div class="business-license-section">
          <div class="business-license-header">
            <span><i class="el-icon-document"></i> 营业执照</span>
          </div>
          <el-upload
            action="#"
            :auto-upload="false"
            :limit="1"
            :file-list="businessLicenseFileList"
            :on-change="handleBusinessLicenseChange"
            :on-remove="handleBusinessLicenseRemove"
            :on-exceed="handleBusinessLicenseExceed"
            accept=".pdf,.jpg,.jpeg,.png"
          >
            <el-button size="small" type="primary" icon="el-icon-upload2">
              {{ currentBusinessLicense ? '选择新营业执照' : '选择营业执照' }}
            </el-button>
            <div slot="tip" class="el-upload__tip">支持 PDF、JPG、PNG，单文件不超过 50MB，保存单位后上传</div>
          </el-upload>
          <div v-if="currentBusinessLicense" class="current-license">
            <div
              v-if="isBusinessLicenseImage"
              v-loading="businessLicensePreviewLoading"
              class="license-thumbnail-wrap"
            >
              <el-image
                v-if="businessLicensePreviewUrl"
                class="license-thumbnail"
                :src="businessLicensePreviewUrl"
                :preview-src-list="[businessLicensePreviewUrl]"
                fit="cover"
                title="点击放大查看"
              >
                <div slot="error" class="license-preview-error">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div v-else class="license-file-icon">
              <i class="el-icon-document"></i>
            </div>
            <div class="current-license-info">
              <span class="current-license-name">{{ currentBusinessLicense.originalName }}</span>
              <div class="current-license-actions">
                <el-button v-permission="'basic:units-list:download-business-license'" type="text" size="mini" icon="el-icon-download" @click="downloadBusinessLicense">下载</el-button>
                <el-button type="text" size="mini" class="license-delete" @click="deleteBusinessLicense">删除</el-button>
              </div>
            </div>
          </div>
        </div>

         <!-- 银行信息管理部分 -->
         <div class="bank-section">
           <div class="bank-section-header">
             <div class="section-title">
               <i class="el-icon-message"></i>
               <span>银行信息</span>
             </div>
             <el-button type="primary" size="small" @click="handleAddBank">
               <i class="el-icon-plus"></i>
               新增银行
             </el-button>
           </div>
           
           <div class="bank-table-container">
             <el-table
               :data="bankInfos"
               border
               stripe
               style="width: 100%"
               :header-cell-style="{background:'#f5f7fa', color:'#606266'}"
               empty-text="暂无银行信息，点击新增银行按钮添加"
               max-height="300"
             >
               <el-table-column prop="bankName" label="银行名称" show-overflow-tooltip></el-table-column>
               <el-table-column prop="bankAccount" label="银行账号" show-overflow-tooltip></el-table-column>
               <el-table-column prop="bankBranch" label="开户行" show-overflow-tooltip></el-table-column>
               <el-table-column prop="accountType" label="账户类型" width="90" align="center">
                 <template slot-scope="scope">
                   <el-tag :type="scope.row.accountType === '基本户' ? 'primary' : 'info'" size="mini">
                     {{ scope.row.accountType }}
                   </el-tag>
                 </template>
               </el-table-column>
               <el-table-column prop="isPrimary" label="主要账户" width="90" align="center">
                 <template slot-scope="scope">
                   <el-tag :type="scope.row.isPrimary ? 'success' : 'info'" size="mini">
                     {{ scope.row.isPrimary ? '是' : '否' }}
                   </el-tag>
                 </template>
               </el-table-column>
               <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                 <template slot-scope="scope">
                   {{ scope.row.remark || '-' }}
                 </template>
               </el-table-column>
               <el-table-column label="操作" width="120" align="center">
                 <template slot-scope="scope">
                   <el-button type="text" size="mini" @click="handleEditBank(scope.$index)" class="edit-btn">编辑</el-button>
                   <el-button type="text" size="mini" @click="handleDeleteBank(scope.$index)" class="delete-btn">删除</el-button>
                 </template>
               </el-table-column>
             </el-table>
           </div>
         </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">保存</el-button>
      </div>
    </el-dialog>
    
    <!-- 删除确认对话框 -->
    <el-dialog
      title="提示"
      :visible.sync="deleteDialogVisible"
      width="400px"
      center
      :close-on-click-modal="false"
    >
      <div class="delete-dialog-content">
        <i class="el-icon-warning-outline warning-icon"></i>
        <span>确认删除该单位信息吗？</span>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="deleteDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="confirmDelete">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 银行信息编辑对话框 -->
    <el-dialog 
      :title="bankEditIndex === -1 ? '新增银行信息' : '编辑银行信息'" 
      :visible.sync="showBankDialog"
      width="600px"
      :before-close="cancelBankForm">
      <el-form ref="bankForm" :model="bankForm" :rules="bankRules" label-width="100px">
        <el-form-item label="银行名称" prop="bankName">
          <el-input v-model="bankForm.bankName" placeholder="请输入银行名称"></el-input>
        </el-form-item>
        <el-form-item label="银行账号" prop="bankAccount">
          <el-input v-model="bankForm.bankAccount" placeholder="请输入银行账号"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="bankBranch">
          <el-input v-model="bankForm.bankBranch" placeholder="请输入开户行"></el-input>
        </el-form-item>
        <el-form-item label="账户类型" prop="accountType">
          <el-select v-model="bankForm.accountType" placeholder="请选择账户类型" style="width: 100%">
            <el-option label="基本户" value="基本户"></el-option>
            <el-option label="一般户" value="一般户"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主要账户">
          <el-switch v-model="bankForm.isPrimary"></el-switch>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="bankForm.remark" type="textarea" :rows="3" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBankForm">取消</el-button>
        <el-button type="primary" @click="submitBankForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'
import {
  deleteBusinessDocument,
  downloadBusinessDocument,
  getBusinessLicense,
  uploadBusinessLicense
} from '@/api/modules/business-document'

export default {
  name: 'UnitInfo',
  data() {
    return {
      // 搜索表单
      searchForm: {
        unitName: '',
        contactPerson: '',
        phone: ''
      },
      // 加载状态
      loading: false,
      // 表格数据
      tableData: [],
      // 分页配置
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      // 对话框
      dialogVisible: false,
      dialogStatus: 'add', // 'add' 或 'edit'
      deleteDialogVisible: false,
      deleteId: null,
      // 表单数据
      unitForm: {
        id: null,
        unitName: '',
        contactPerson: '',
        phone: '',
        taxId: '',
        address: '',
        unitShortName: '', // 单位简称
        shortNameInitial: '' // 简称首字母
      },
      // 银行信息数组
      bankInfos: [],
      // 银行表单数据
      bankForm: {
        bankName: '',
        bankAccount: '',
        bankBranch: '',
        accountType: '基本户',
        isPrimary: false,
        remark: ''
      },
      // 银行信息对话框
      showBankDialog: false,
      bankEditIndex: -1,
      businessLicenseFile: null,
      businessLicenseFileList: [],
      currentBusinessLicense: null,
      businessLicensePreviewUrl: '',
      businessLicensePreviewLoading: false,
      // 表单验证规则
      rules: {
        unitName: [
          { required: true, message: '请输入单位名称', trigger: 'blur' }
        ],
        contactPerson: [
          { required: true, message: '请输入联系人', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系人电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        taxId: [
          { required: true, message: '请输入税号', trigger: 'blur' }
        ],
        address: [
          { required: true, message: '请输入单位地址', trigger: 'blur' }
        ],
        unitShortName: [
          { required: true, message: '请输入单位简称', trigger: 'blur' },
          { min: 1, max: 6, message: '单位简称长度在 1 到 6 个字符', trigger: 'blur' }
        ],
        shortNameInitial: [
          { required: true, message: '请输入简称首字母', trigger: 'blur' },
          { min: 1, max: 6, message: '简称首字母长度在 1 到 6 个字符', trigger: 'blur' }
        ]
      },
      // 银行信息验证规则
      bankRules: {
        bankName: [
          { required: true, message: '请输入银行名称', trigger: 'blur' }
        ],
        bankAccount: [
          { required: true, message: '请输入银行账号', trigger: 'blur' }
        ],
        bankBranch: [
          { required: true, message: '请输入开户行', trigger: 'blur' }
        ],
        accountType: [
          { required: true, message: '请选择账户类型', trigger: 'change' }
        ]
      }
    }
  },
  created() {
    this.fetchUnitList();
  },
  computed: {
    isBusinessLicenseImage() {
      if (!this.currentBusinessLicense) return false;
      const fileType = (this.currentBusinessLicense.fileType || '').toLowerCase();
      const fileName = (this.currentBusinessLicense.originalName || '').toLowerCase();
      return fileType.startsWith('image/') || /\.(jpg|jpeg|png)$/.test(fileName);
    }
  },
  beforeDestroy() {
    this.clearBusinessLicensePreview();
  },
  methods: {
    // 获取单位列表
    fetchUnitList() {
      this.loading = true;
      
      // 构建查询参数 - 根据新接口调整参数名称
      const params = {
        page: this.pagination.currentPage - 1, // 后端从0开始，前端从1开始
        size: this.pagination.pageSize,
        sortBy: 'id',
        sortDir: 'desc'
      };
      
      // 添加搜索条件（如果后端支持的话）
      if (this.searchForm.unitName) {
        params.unitName = this.searchForm.unitName;
      }
      if (this.searchForm.contactPerson) {
        params.contactPerson = this.searchForm.contactPerson;
      }
      if (this.searchForm.phone) {
        params.phone = this.searchForm.phone;
      }
      
api.unit.query_unit_pagination(params)
        .then(response => {
if (response.data && response.data.success) {
            const responseData = response.data.data;
            // 数据直接在 data.content 中
            this.tableData = responseData.content || [];
            
            // 更新分页信息 - 使用Spring Data分页对象的字段
            this.pagination = {
              currentPage: responseData.number + 1, // 后端从0开始，前端从1开始
              pageSize: responseData.size,
              total: responseData.totalElements
            };
          } else {
            this.$message.error(response.data.message || '查询失败');
          }
        })
        .catch(error => {
          console.error('查询单位列表失败: ', error);
          this.$message.error('查询单位列表失败，请稍后重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 搜索方法
    handleSearch() {
      this.pagination.currentPage = 1; // 重置为第一页
      this.fetchUnitList();
    },
    
    // 显示新增对话框
    showAddDialog() {
      this.dialogStatus = 'add';
      this.resetForm();
      this.dialogVisible = true;
    },
    
    // 编辑操作
    handleEdit(row) {
      this.dialogStatus = 'edit';
      
      // 先获取详细信息再编辑
      this.loading = true;
      api.unit.query_unit_by_id(row.id)
        .then(response => {
          if (response.data && response.data.success) {
            const unitData = response.data.data || {};
            this.unitForm = {
              id: unitData.id,
              unitName: unitData.unitName || '',
              contactPerson: unitData.contactPerson || '',
              phone: unitData.phone || '',
              taxId: unitData.taxId || '',
              address: unitData.address || '',
              unitShortName: unitData.unitShortName || '',
              shortNameInitial: unitData.shortNameInitial || ''
            };
            // 处理银行信息
            this.bankInfos = unitData.bankInfos || [];
            this.businessLicenseFile = null;
            this.businessLicenseFileList = [];
            this.currentBusinessLicense = null;
            this.clearBusinessLicensePreview();
            this.loadBusinessLicense(unitData.id);
            this.dialogVisible = true;
          } else {
            this.$message.error('获取单位详情失败');
          }
        })
        .catch(error => {
          console.error('获取单位详情失败: ', error);
          this.$message.error('获取单位详情失败，请稍后重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 删除操作
    handleDelete(row) {
      this.deleteId = row.id;
      this.deleteDialogVisible = true;
    },
    
    // 确认删除
    confirmDelete() {
      this.loading = true;
      
      // 使用delete_unit_by_id方法删除单位
      api.unit.delete_unit_by_id(this.deleteId)
        .then(response => {
if (response.data && response.data.success) {
            this.$message.success(response.data.message || '删除成功');
            // 删除成功后更新列表
            this.tableData = this.tableData.filter(item => item.id !== this.deleteId);
            this.pagination.total -= 1;
            this.deleteDialogVisible = false;
          } else {
            this.$message.error(response.data.message || '删除失败');
          }
        })
        .catch(error => {
          console.error('删除单位失败: ', error);
          this.$message.error('删除单位失败，请稍后重试');
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 重置表单
    resetForm() {
      this.unitForm = {
        id: null,
        unitName: '',
        contactPerson: '',
        phone: '',
        taxId: '',
        address: '',
        unitShortName: '', // 单位简称
        shortNameInitial: '' // 简称首字母
      };
      this.bankInfos = [];
      this.businessLicenseFile = null;
      this.businessLicenseFileList = [];
      this.currentBusinessLicense = null;
      this.clearBusinessLicensePreview();
      if (this.$refs.unitForm) {
        this.$refs.unitForm.resetFields();
      }
    },
    
    // 提交表单
    submitForm() {
      this.$refs.unitForm.validate(valid => {
        if (valid) {
          this.loading = true;
          
          // 准备提交的数据
          const submitData = {
            ...this.unitForm,
            bankInfos: this.bankInfos,
            is_update: this.dialogStatus === 'edit'
          };
          
// 调用保存API
          api.unit.save_unit_info(submitData)
            .then(async response => {
if (response.data && response.data.success) {
                const savedUnit = response.data.data || {};
                const savedUnitId = savedUnit.id || this.unitForm.id;
                if (this.businessLicenseFile && savedUnitId) {
                  try {
                    const licenseResponse = await uploadBusinessLicense(savedUnitId, this.businessLicenseFile);
                    if (!licenseResponse.data || !licenseResponse.data.success) {
                      throw new Error(licenseResponse.data && licenseResponse.data.message
                        ? licenseResponse.data.message
                        : '营业执照上传失败');
                    }
                  } catch (error) {
                    this.unitForm.id = savedUnitId;
                    this.dialogStatus = 'edit';
                    this.$message.warning('单位已保存，但营业执照上传失败，请重新选择后保存');
                    this.fetchUnitList();
                    return;
                  }
                }
                this.$message.success(response.data.message || '保存成功');
                this.dialogVisible = false;
                // 重新加载列表
                this.fetchUnitList();
              } else {
                this.$message.error(response.data.message || '保存失败');
              }
            })
            .catch(error => {
              console.error('保存单位失败: ', error);
              this.$message.error('保存单位失败，请稍后重试');
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          return false;
        }
      });
    },

    handleBusinessLicenseChange(file, fileList) {
      if (file.size > 50 * 1024 * 1024) {
        this.$message.error('营业执照文件不能超过 50MB');
        this.businessLicenseFile = null;
        this.businessLicenseFileList = [];
        return;
      }
      this.businessLicenseFile = file.raw;
      this.businessLicenseFileList = fileList.slice(-1);
    },

    handleBusinessLicenseRemove() {
      this.businessLicenseFile = null;
      this.businessLicenseFileList = [];
    },

    handleBusinessLicenseExceed(files) {
      this.businessLicenseFile = files[0];
      this.businessLicenseFileList = [{ name: files[0].name, raw: files[0] }];
    },

    async loadBusinessLicense(unitId) {
      try {
        const response = await getBusinessLicense(unitId);
        this.currentBusinessLicense = response.data && response.data.success && response.data.data.length
          ? response.data.data[0]
          : null;
        await this.loadBusinessLicensePreview();
      } catch (error) {
        console.error('获取营业执照失败:', error);
        this.currentBusinessLicense = null;
        this.clearBusinessLicensePreview();
      }
    },

    async loadBusinessLicensePreview() {
      this.clearBusinessLicensePreview();
      if (!this.isBusinessLicenseImage) return;

      const documentId = this.currentBusinessLicense.id;
      this.businessLicensePreviewLoading = true;
      try {
        const response = await downloadBusinessDocument(documentId);
        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || this.currentBusinessLicense.fileType || 'image/jpeg'
        });
        const previewUrl = window.URL.createObjectURL(blob);
        if (!this.dialogVisible || !this.currentBusinessLicense || this.currentBusinessLicense.id !== documentId) {
          window.URL.revokeObjectURL(previewUrl);
          return;
        }
        this.businessLicensePreviewUrl = previewUrl;
      } catch (error) {
        console.error('营业执照预览加载失败:', error);
        this.$message.warning('营业执照预览加载失败，可下载后查看');
      } finally {
        if (this.currentBusinessLicense && this.currentBusinessLicense.id === documentId) {
          this.businessLicensePreviewLoading = false;
        }
      }
    },

    clearBusinessLicensePreview() {
      if (this.businessLicensePreviewUrl) {
        window.URL.revokeObjectURL(this.businessLicensePreviewUrl);
      }
      this.businessLicensePreviewUrl = '';
      this.businessLicensePreviewLoading = false;
    },

    handleUnitDialogClosed() {
      this.clearBusinessLicensePreview();
    },

    async downloadBusinessLicense() {
      if (!this.currentBusinessLicense) return;
      try {
        const response = await downloadBusinessDocument(this.currentBusinessLicense.id);
        const blob = new Blob([response.data], {
          type: response.headers['content-type'] || 'application/octet-stream'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = this.currentBusinessLicense.originalName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        this.$message.error('营业执照下载失败');
      }
    },

    async deleteBusinessLicense() {
      if (!this.currentBusinessLicense) return;
      try {
        await this.$confirm('确定删除当前营业执照吗？', '提示', { type: 'warning' });
        const response = await deleteBusinessDocument(this.currentBusinessLicense.id);
        if (!response.data || !response.data.success) {
          throw new Error(response.data && response.data.message ? response.data.message : '删除失败');
        }
        this.currentBusinessLicense = null;
        this.clearBusinessLicensePreview();
        this.$message.success('营业执照删除成功');
      } catch (error) {
        if (error !== 'cancel' && error !== 'close') {
          this.$message.error(error.message || '营业执照删除失败');
        }
      }
    },
    
    // 分页大小变化
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.fetchUnitList();
    },
    
    // 页码变化
    handleCurrentChange(val) {
      this.pagination.currentPage = val;
      this.fetchUnitList();
    },
    
    // 银行信息管理方法
    handleAddBank() {
      this.bankForm = {
        bankName: '',
        bankAccount: '',
        bankBranch: '',
        accountType: '基本户',
        isPrimary: false,
        remark: ''
      };
      this.bankEditIndex = -1;
      this.showBankDialog = true;
    },
    handleEditBank(index) {
      this.bankForm = { ...this.bankInfos[index] };
      this.bankEditIndex = index;
      this.showBankDialog = true;
    },
    handleDeleteBank(index) {
      this.$confirm('确认要删除这条银行信息吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.bankInfos.splice(index, 1);
        this.$message.success('删除成功');
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    submitBankForm() {
      this.$refs.bankForm.validate(valid => {
        if (valid) {
          if (this.bankEditIndex === -1) {
            // 新增
            this.bankInfos.push({ ...this.bankForm });
          } else {
            // 编辑
            this.$set(this.bankInfos, this.bankEditIndex, { ...this.bankForm });
          }
          this.showBankDialog = false;
          this.$message.success(this.bankEditIndex === -1 ? '新增成功' : '编辑成功');
        }
      });
    },
    cancelBankForm() {
      this.showBankDialog = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.unit-info-container {
  background-color: #fff;
  padding: 20px;
  min-height: calc(100vh - 120px);
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.05);
  
  .page-header {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    
    .blue-bar {
      width: 3px;
      background-color: #1890ff;
      height: 16px;
      margin-right: 8px;
    }
    
    .page-title {
      font-size: 16px;
      font-weight: 500;
      color: #333;
      margin: 0;
    }
  }
  
  .search-area {
    margin-bottom: 20px;
    
    .search-inputs {
      display: flex;
      flex-wrap: wrap;
      
      .search-item {
        margin-right: 15px;
        margin-bottom: 10px;
        width: 200px;
      }
      
      .search-buttons {
        display: flex;
        align-items: flex-start;
        
        .el-button {
          margin-right: 10px;
        }
      }
    }
  }
  
     .table-container {
     .el-table {
       margin-bottom: 20px;
       
       // 确保表格支持横向滚动
       .el-table__body-wrapper {
         overflow-x: auto;
       }
       
       // 删除固定最小宽度，让表格自适应内容宽度
       .el-table__body {
         width: 100%;
       }
     }
     
     .edit-btn {
       color: #1890ff;
       margin-right: 15px;
     }
     
     .delete-btn {
       color: #f56c6c;
     }
   }
  
  .pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
  }
  
  .delete-dialog-content {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px 0;
    
    .warning-icon {
      font-size: 24px;
      color: #e6a23c;
      margin-right: 10px;
    }
    
    span {
      font-size: 16px;
    }
  }
  
  .unit-dialog {
    :deep(.el-dialog__header) {
      padding: 15px 20px;
      background-color: #f8f9fc;
      text-align: center;
    }
    
    :deep(.el-dialog__title) {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }
    
    :deep(.el-dialog__body) {
      padding: 20px;
    }
    
    :deep(.el-form-item__label) {
      color: #606266;
      font-weight: normal;
    }
    
    :deep(.el-input__inner) {
      height: 36px;
      line-height: 36px;
      border-radius: 2px;
    }
    
    :deep(.el-dialog__footer) {
      padding: 10px 20px 20px;
      text-align: center;
    }
    
    :deep(.el-dialog__headerbtn) {
      top: 15px;
    }
  }
  
  .business-license-section {
    margin: 8px 0 20px;
    padding: 16px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    background: #fafafa;
  }

  .business-license-header {
    margin-bottom: 12px;
    color: #303133;
    font-weight: 500;
  }

  .current-license {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 10px;
  }

  .license-thumbnail-wrap,
  .license-thumbnail,
  .license-file-icon {
    width: 88px;
    height: 64px;
    flex: 0 0 88px;
    border-radius: 4px;
  }

  .license-thumbnail-wrap {
    overflow: hidden;
    border: 1px solid #dcdfe6;
    background: #f5f7fa;
  }

  .license-thumbnail {
    display: block;
    cursor: zoom-in;
  }

  .license-preview-error,
  .license-file-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #909399;
    font-size: 26px;
    background: #f5f7fa;
  }

  .current-license-info {
    min-width: 0;
    flex: 1;
  }

  .current-license-name {
    display: block;
    max-width: 470px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .current-license-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 2px;

    .el-button + .el-button {
      margin-left: 0;
    }
  }

  .license-delete {
    color: #f56c6c;
  }

  // 银行信息管理样式
  .bank-section {
    margin-top: 20px;
    border: 1px solid #ebeef5;
    border-radius: 4px;
    padding: 15px;
    background-color: #f9f9f9;
    
    .bank-section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 15px;
      
      .section-title {
        display: flex;
        align-items: center;
        
        i {
          color: #1890ff;
          font-size: 16px;
          margin-right: 6px;
        }
        
        span {
          font-size: 14px;
          font-weight: 500;
          color: #333;
        }
      }
      
      .el-button {
        font-size: 12px;
        
        i {
          margin-right: 4px;
        }
      }
    }
    
    .bank-table-container {
      .el-table {
        font-size: 14px;
        
        .el-table__empty-text {
          color: #909399;
        }
        
        .edit-btn {
          color: #1890ff;
          margin-right: 8px;
          
          &:hover {
            color: #40a9ff;
          }
        }
        
        .delete-btn {
          color: #f56c6c;
          
          &:hover {
            color: #f78989;
          }
        }
      }
    }
  }

  // 删除确认对话框样式
  :deep(.el-dialog) {
    border-radius: 4px;
    overflow: hidden;
  }
}

/* 全局对话框样式，确保对话框在页面中心 */
.el-dialog__wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  
  .el-dialog {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 60px);   /* 限制最大高度 */
    
    .el-dialog__body {
      overflow-y: auto;               /* 内容过多时出现滚动条 */
      flex: 1;
    }
  }
}
</style>
